var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { QualifioEmbed } from "core/components/QualifioEmbed";
import { IframeEmbed } from "core/components/IframeEmbed";
import { EmbedType } from "core/codegen/types";
export function renderEmbed(embed) {
    var _a, _b;
    switch (embed.type) {
        case EmbedType.IFrame:
            return (React.createElement(StyledIframeEmbed, { url: embed.url, height: "100vh", displayMode: embed.displayMode, bgColor: (_a = embed.bgColor) !== null && _a !== void 0 ? _a : undefined }));
        case EmbedType.Qualifio:
            return (React.createElement(QualifioEmbed, { html: embed.html, script: embed.script, displayMode: embed.displayMode, bgColor: (_b = embed.bgColor) !== null && _b !== void 0 ? _b : undefined }));
        case EmbedType.Spotify:
            return null;
    }
}
export var FullscreenView = function (_a) {
    var data = _a.data;
    if (data.embed === null)
        return null;
    return renderEmbed(data.embed);
};
var StyledIframeEmbed = styled(IframeEmbed)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100vh;\n"], ["\n  height: 100vh;\n"])));
var templateObject_1;
